import { Controller } from "@hotwired/stimulus"

// Kept so older cached pages with data-controller="drop-in-checkout" do not
// error. Navigation to Stripe is a turbo-stream redirect action now.
export default class extends Controller {}
